module.exports = require("@mui/icons-material/Recommend");